import { CSSProperties } from 'react';
import cn from 'classnames';
import styles from './shadowBox.module.scss';

export interface ShadowBoxProps {
    targetClass?: string;
    children: React.ReactNode;
    animateOnHoverMobile?: boolean;
    animateOnHoverDesktop?: boolean;
    roundedBorder?: boolean;
}

export function ShadowBox({
    targetClass = '',
    children,
    animateOnHoverMobile = false,
    animateOnHoverDesktop = false,
    roundedBorder,
}: ShadowBoxProps) {
    const classNames = cn(styles.shadowBox, targetClass, {
        [styles.animateOnHoverMobile]: animateOnHoverMobile,
        [styles.animateOnHoverDesktop]: animateOnHoverDesktop,
    });

    const roundedBorderStyle = { '--border-w2-radius': '24px' } as CSSProperties;

    return (
        <div className={classNames} style={roundedBorder ? roundedBorderStyle : {}}>
            {children}
        </div>
    );
}
